import { useQuery } from "@tanstack/react-query";

import { getStageStatus } from "@/adapters/api";
import { chartKeys } from "../utils/query-keys.ts";

const STALE_TIME = 60_000;

export interface UseStageStatusParams {
	constructionId: string | undefined;
	referenceDate: string;
	enabled?: boolean;
}

export function useStageStatus({
	constructionId,
	referenceDate,
	enabled = true,
}: UseStageStatusParams) {
	return useQuery({
		queryKey: chartKeys.stageStatus(constructionId, referenceDate),
		queryFn: () =>
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			getStageStatus(constructionId!, { referenceDate }),
		enabled: enabled && !!constructionId,
		staleTime: STALE_TIME,
	});
}
